import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
  WhatsappMessageModel,
  WhatsappMessageType,
} from "@jugl-web/rest-api";

export const whatsappMessageToAttachmentPayload = (
  payload: WhatsappMessageModel["payload"]
): ChatMessagePayloadAttachment | null => {
  if (
    ![
      WhatsappMessageType.image,
      WhatsappMessageType.video,
      WhatsappMessageType.sticker,
      WhatsappMessageType.audio,
      WhatsappMessageType.document,
    ].includes(payload.type)
  ) {
    return null;
  }

  let attachmentType: ChatMessageAttachmentType;
  let mimetype = "application/octet-stream";
  let name: string;
  let mediaId: string | undefined;

  switch (payload.type) {
    case WhatsappMessageType.image:
      mimetype = payload.image.mime_type || "image/*";
      attachmentType = ChatMessageAttachmentType.image;
      mediaId = payload.image.id;
      name = payload.image.caption || "Image";
      break;
    case WhatsappMessageType.video:
      mimetype = payload.video.mime_type || "video/*";
      attachmentType = ChatMessageAttachmentType.video;
      mediaId = payload.video.id;
      name = payload.video.caption || "Video";
      break;
    case WhatsappMessageType.sticker:
      mimetype = payload.sticker.mime_type || "image/*";
      attachmentType = ChatMessageAttachmentType.gifDirectUrl;
      mediaId = payload.sticker.id;
      name = "Sticker";
      break;
    case WhatsappMessageType.audio:
      mimetype = payload.audio.mime_type || "audio/*";
      attachmentType = ChatMessageAttachmentType.audio;
      mediaId = payload.audio.id;
      name = payload.audio.filename || "Audio";
      break;
    case WhatsappMessageType.document:
      mimetype = payload.document.mime_type || "application/octet-stream";
      attachmentType = ChatMessageAttachmentType.otherFile;
      mediaId = payload.document.id;
      name = payload.document.filename || "File";
      break;
    default:
      return null;
  }

  return {
    type: attachmentType,
    uid: mediaId || Math.round(Math.random() * 1e8).toString(),
    mimetype,
    name,
    size: 0,
  };
};
